module.exports = __webpack_public_path__ + "static/media/instragram1.8450630b.jpg";